import { render, staticRenderFns } from "./selectTemplateTutorial.vue?vue&type=template&id=668281de&"
import script from "./selectTemplateTutorial.vue?vue&type=script&lang=ts&"
export * from "./selectTemplateTutorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports